import { NextPage } from 'next';
import { Fragment, useState } from 'react';
// -------- custom component -------- //
import Navbar from 'components/blocks/navbar/Navbar';
import { Footer1 } from 'components/blocks/footer';
import { LocalSEO } from 'components/blocks/portfolio';
import PageProgress from 'components/common/PageProgress';
import NextLink from 'components/reuseable/links/NextLink';
import SEO from 'components/common/SEO';
import Image from 'next/image';
import * as All from 'data/keywords';
import ProjectDetailsContent from 'components/common/ProjectDetailsContent';
import ProjectDetailsNavigation from 'components/common/ProjectDetailsNavigation';
import ContactFooterCombo from 'components/reuseable/ContactFooterCombo';

const details = {
  pageName: 'Charlotte Watts Yoga',
  categories: 'digital marketing, health',
  description:
    'Charlotte Watts is a yoga teacher, nutritionist and GTV presenter. Charlotte wanted a website that would help her to promote her yoga classes and workshops. She also wanted to be able to update her website herself. We created a bespoke website for Charlotte using WordPress as a part of our Digital Marketing for Health and Wellness package. ',
  parentDirectories: 'seo-design-portfolio'
};

const contentRowClass = 'row gx-0';
const titleClass = 'display-6 mb-4';
const Portfolio = All.LocalSEOArrays[6].keywords;

const ProjectDetails: NextPage = () => {
  return (
    <Fragment>
      {/* <PageProgress /> */}{' '}
      <main className="content-wrapper">
        <SEO
          title={`${Portfolio[0].title} - ${details.pageName}`}
          description={details.description}
          tag={details.categories}
          urlPT={``}
          urlENPT={``}
          url={`${Portfolio[0].url}/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}`}
          image={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
          // updated=""
          // published=""
          // modified=""
        />
        {/* ========== heading section ========== */}
        <section className="overflow-hidden position-relative green">
          <div className="h-min-100vh h-md-auto color w-100"></div>
          <div className="container gx-0 text-center mt-n10 wrapper image-wrapper bg-image bg-overlay text-white overflow-hidden h-min-100vh h-md-auto d-flex align-items-center">
            <div className="h-100 w-100 hero-portfolio position-absolute left-0">
              <img
                className="w-100 object-fit-cover h-min-100vh h-md-auto w-min-100"
                src={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg.jpg`}
                // srcSet={`/img/clients/${Portfolio[1].title.toLowerCase().replace(/ /g, '-')}-bg@2x.jpg 2x`}
                alt={`${Portfolio[1].title}`}
              />
              <div></div>
            </div>
            <div className="row mx-auto">
              <div className="col-md-12 mx-auto text-center">
                <div className="post-header mx-auto text-center">
                  {/* <div className="post-category text-line text-white">Identity</div> */}

                  <h1 className="fs-15 text-uppercase text-white mb-3">- {Portfolio[0].title} -</h1>
                  <p className="display-4 text-capitalize">{details.pageName}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="wrapper bg-light wrapper-border">
          {/* ========== details section ========== */}
          <div className="container pt-14 pt-md-16 pb-13 pb-md-15 pe-md-10">
            <div className="row">
              <div className="col-lg-12 offset-lg-0">
                <h2 className={titleClass}>{Portfolio[0].title}</h2>

                <div className={`overflow-hidden ${contentRowClass}`}>
                  <div className="col-md-9 text-justify order-0 pe-10">
                    <h2 className="display-6 mb-4">{details.pageName}</h2>
                    <p>
                      <strong className="caption">{details.description}</strong>
                    </p>
                    <p>
                      At SEOptimist  <NextLink title={All.HomeList[1].title} href="/" />, we understand the importance of
                      effective digital marketing strategies for healthcare professionals, and we're proud to have
                      helped Charlotte Watts Health achieve significant success with her online presence.
                    </p>
                    <h3>{Portfolio[1].title}</h3>
                    <p>
                      As a Nutritional Therapist and Senior Yoga Alliance Yoga Teacher and Trainer with nearly 20 years
                      of experience, Charlotte Watts Health needed a website that could showcase her expertise and
                      services to potential clients. With the help of SEOptimist, she was able to achieve this goal and
                      more.
                    </p>
                    <h3>
                      {Portfolio[3].title}
                      {/* <h3>{Portfolio[1].title}</h3> */}
                    </h3>
                    <p>
                      Our team provided a bespoke {Portfolio[3].title} and developed a custom WordPress website for
                      Charlotte Watts Health, which has been optimized for search engines and user experience. We
                      ensured that the website's design was modern, user-friendly, and visually appealing, with clear
                      calls-to-action throughout the site to encourage visitors to engage with Charlotte and her
                      services.
                    </p>
                    <img
                      width={'100%'}
                      height={'auto'}
                      src={`/img/clients/${Portfolio[0].title.toLowerCase().replace(/ /g, '-')}.jpg`}
                      alt={Portfolio[0].title}
                      style={{ background: 'transparent', maxWidth: '666px' }}
                    />
                    <h3>Healthcare SEO</h3>
                    <p>
                      Our Healthcare SEO experts also conducted keyword research and implemented on-page optimization
                      techniques to help Charlotte's website rank higher on search engines. As a result, her website now
                      ranks for various relevant keywords, bringing in a steady stream of organic traffic to her site.
                    </p>
                    <h3>{Portfolio[4].title}</h3>
                    <p>
                      SEOptimist  <span className="text-capitalize">{Portfolio[4].title}</span> also set up a content
                      marketing strategy for Charlotte, which involves regularly publishing informative blog posts
                      related to her areas of expertise. Our team created high-quality content that provides value to
                      her audience and establishes her as an authority in her field. These blog posts are also optimized
                      for search engines, driving more traffic to her website and generating leads.
                    </p>
                    <h3>
                      Medical SEO
                      {/* {Portfolio[5].title} */}
                    </h3>
                    <p>
                      Overall, the Medical SEO digital marketing strategies we implemented for Charlotte Watts Health
                      have helped her grow her online presence and attract new clients. With a well-designed website and
                      effective SEO and content marketing techniques, Charlotte is now able to promote her services and
                      expertise to a wider audience.
                    </p>
                    <p>
                      <strong>
                        We understand the unique challenges that healthcare professionals face when it comes to digital
                        marketing.
                      </strong>{' '}
                      That's why we offer customized solutions to help healthcare and wellness providers achieve their
                      online goals. Contact us today to learn more about our digital health marketing agency and
                      healthcare SEO services.
                    </p>{' '}
                    <p></p>
                    <NextLink title="Contact" href="/#contact" className="more hover" />
                  </div>

                  <div className="col-md-3 ms-auto order-1 pt-10">
                    <ul className="list-unstyled">
                      <li>
                        <h5 className="mb-1">Categories</h5>
                        <p>{details.categories}</p>
                      </li>

                      <li>
                        <h5 className="mb-1">Client Name</h5>
                        <p>{details.pageName}</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* ========== portfolio section ========== */}

            <LocalSEO initialslide={0} />
          </div>
        </section>

        {/* ========== navigation section ========== */}
        <ProjectDetailsNavigation />
      </main>
      <ContactFooterCombo location="london" />
    </Fragment>
  );
};

export default ProjectDetails;
